import { StoreCupboardCard } from '../components/StoreCupboardCard';
import type { Language, Me } from '../types';

const TITLES = {
  en: 'The store cupboard',
  fr: 'Le placard',
} as const;

/**
 * The store cupboard, in its own right (§20).
 *
 * It started life buried at the bottom of Settings, which was wrong: settings
 * are things you set once and forget, and this is a live picture of what is in
 * the house. It changes every time a shop is finished, it is worth glancing at
 * before planning a week, and it is the thing you check when you cannot
 * remember whether there is still hoisin.
 */
export function CupboardPage({ language, me }: { language: Language; me: Me }) {
  return (
    <div className="stack">
      <h1 className="page-title">{TITLES[language]}</h1>
      <StoreCupboardCard language={language} readOnly={me.actor?.kind === 'device'} />
    </div>
  );
}
